import axios from 'axios'

export const http = axios.create({ baseURL: 'https://api.energievolutie.nl' })

// export const http = (process.env.NODE_ENV == 'development') ? 
//     axios.create({ baseURL: 'http://localhost:5000' }) : // use for development if running into CORS problems
//     // axios.create({ baseURL: 'https://api.energievolutie.nl' }) :
//     axios.create({ baseURL: 'https://api.energievolutie.nl' })